import Vue from 'vue'
import Router from 'vue-router'

// 聊天路由
import chatRouter from '../routers/chatRouter.js';
//通讯录路由
import mailList from "@/routers/mailList.js";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home',
      redirect: "/home/chatIndex"
    },
    {
      path: '/',
      name: 'logo',
      component: () => import("@/components/logo.vue")
    },
    {
      path: '/electronTabs',
      name: 'electronTabs',
      component: () => import("@/pages/electronTabs/ElectronTabs.vue"),
      meta: {
        // 页面标题title
        title: '经营帮-v1.0.0'
      }
    },
    {
      path: '/electronTabs1',
      name: 'electronTabs1',
      component: () => import("@/pages/electronTabs/ElectronTabs-1.vue"),
      meta: {
        // 页面标题title
        title: '经营帮-产业化互联网平台'
      }
    },
    {
      path: '/upgrade',
      name: 'upgrade',
      component: () => import('@/pages/upgrade/upgrade.vue')
    },
    {
      path: '/home',
      name: 'home',
      component: () => import("@/components/home.vue"),
      children: [
        ...chatRouter,
        ...mailList
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js